import React from 'react'
import { CardContainer, CardWrapper, CardItem, CardImage,
CardHeading, CardP } from './CardElement'
import { FaChalkboardTeacher, FaDiscourse } from 'react-icons/fa'
import {ImBooks} from "react-icons/im"
import {BiCertification} from "react-icons/bi"

const Cards = () => {
    return (
        <CardContainer>
            <CardWrapper>

                <CardItem data-aos="fade-up">
                    <CardImage>
                        <FaChalkboardTeacher/>
                        </CardImage>
                    <CardHeading>Certified Teachers</CardHeading>
                    <CardP>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolor, 
                        illo consectetur nisi odio cum suscipit</CardP>
                </CardItem>

                <CardItem data-aos="fade-up">
                <CardImage>
                        <FaDiscourse/>
                        </CardImage>
                    <CardHeading>Trending Courses</CardHeading>
                    <CardP>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolor, 
                        illo consectetur nisi odio cum suscipit</CardP>
                </CardItem>

                
                <CardItem data-aos="fade-up">
                    <CardImage>
                        <ImBooks/>
                        </CardImage>
                    <CardHeading>Books & Library</CardHeading>
                    <CardP>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolor, 
                        illo consectetur nisi odio cum suscipit
                    </CardP>
                </CardItem>

                <CardItem data-aos="fade-up">
                <CardImage>
                        <BiCertification/>
                        </CardImage>
                    <CardHeading>Certification</CardHeading>
                    <CardP>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolor, 
                        illo consectetur nisi odio cum suscipit</CardP>
                </CardItem>

            </CardWrapper>
        </CardContainer>
    )
}

export default Cards
